<template>
  <div class="invite" id="invite">
    <div class="main">
      <div @click="activityDetail" class="detail">活动细则</div>
      <img src="../assets/images/kuaigui_text.png" alt="" class="kuaigui_text"/>
      <div class="img">
        <img src="../assets/images/invite_friend.png" alt="" class="invite_friend"/>
        <img src="../assets/images/park_discount.png" alt="" class="park_discount"/>
      </div>
      <div class="activity_detail_block">
        <div class="title">
          <img src="../assets/images/block_1_title_left.png" alt=""/>
          <p>活动规则</p>
          <img src="../assets/images/block_1_title_right.png" alt=""/>
        </div>
        <div class="coupon">
          <ul>
            <li>
              <img src="../assets/images/block_1_invite_left.png" alt=""/>
              <p class="friend">好友下载注册</p>
              <p class="coupon_type">无门槛停车券5元*1</p>
            </li>
            <li>
              <img src="../assets/images/block_1_invite_right.png" alt="" class="img"/>
              <p class="friend">好友预约下单</p>
              <p class="coupon_type">无门槛停车券5元*1</p>
            </li>
          </ul>
        </div>
        <div class="btn">
          <button @click="immediatelyInvitation">立即邀请</button>
        </div>
        <img class="ren" src="../assets/images/ren.png" alt="">
        <div class="statement">好友也可获得停车优惠大礼包</div>
      </div>
      <div class="myreward">
        <div class="title">
          <img src="../assets/images/block_1_title_left.png" alt=""/>
          <p>我的奖励</p>
          <img src="../assets/images/block_1_title_right.png" alt=""/>
        </div>
        <div class="reward_content">
          <ul>
            <li>
              <div class="big">{{list.invitedNUm}}
                <div>人</div>
              </div>
              <span>已邀请</span>
            </li>
            <li class="twoborder">
              <div class="big">
                {{list.usedNum}}
                <div>人</div>
              </div>
              <span>已下单</span>
            </li>
            <li>
              <div class="big">
                {{list.discountAmount}}
                <div>元</div>
              </div>
              <span>优惠奖励</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="invite_record">
        <div class="title">
          <img src="../assets/images/block_1_title_left.png" alt=""/>
          <p>邀请记录</p>
          <img src="../assets/images/block_1_title_right.png" alt=""/>
        </div>
        <div class="records">
          <div class="list_null" v-if="list.result.length==0">
            <img src="../assets/images/list_error.png" alt="">
            <div>暂未邀请</div>
          </div>
          <ul v-else>
            <li v-for="(lr,lrIndex) in list.result" v-bind:key="lrIndex">
              <div class="left">{{lr.phone}}</div>
              <div class="time">{{lr.time}}</div>
              <div class="right" v-if="lr.status==0">未下单</div>
              <div class="right ordered" v-else>已下单</div>
            </li>
          </ul>
        </div>
        <!--        <a class="more" href="#" v-show="list.result.length!==0"><u>查看更多邀请记录</u></a>-->
      </div>
    </div>
    <div class="share" id="share" v-if="type!=='wechat'&&type!=='alipay'">
      <ul>
        <li @click="share(1)">
          <a>
            <img src="../assets/images/wxhy.png" alt=""/>
            <p>微信好友</p>
          </a>
        </li>
        <li @click="share(2)">
          <a>
            <img src="../assets/images/pyq.png" alt=""/>
            <p>朋友圈</p>
          </a>
        </li>
        <li @click="share(3)">
          <a>
            <img src="../assets/images/zfb.png" alt=""/>
            <p>支付宝</p>
          </a>
        </li>
        <li @click="share(4)">
          <a>
            <img src="../assets/images/dingding.png" alt=""/>
            <p>钉钉</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  let wx = require('weixin-js-sdk');
  export default {
    name: "Invitation",
    data: function(){
      return{
        list: {
          discountAmount: 0,
          invitedNUm: 0,
          result: [],
          usedNum: 0,
          myInviteCode: ""
        },
        type: "",
        uid: null
      }

    },
    created: function () {
      this.uid = this.$route.query.uid;
      this.type = this.$route.query.type;
      this.getInviteList();
    },
    mounted: function () {

    },
    methods: {
      activityDetail:function(){
        let code = "hdxz";
        this.$router.push({
          path: '/dynamic',
          query: {
            code
          }
        });
      },
      immediatelyInvitation:function(){
        if(this.type==='wechat'){
          // this.$messagebox('wechat',this.uid);
          wx.miniProgram.postMessage({data:'share'});
        }else if(this.type==='alipay'){
          // eslint-disable-next-line no-undef
          my.startShare()
        }else{
          let ele = document.getElementById('invite');
          ele.scrollTop = ele.scrollHeight;
        }
      },
      share:function(status){
        let that = this;
        let type = this.type;
        /**
         * 分享至
         * 1:微信
         * 2:朋友圈
         * 3:支付宝
         * 4:微博
         * */
        if(type==='ios'){
          window.webkit.messageHandlers.shareThird.postMessage({
            status: status,
            invitecode: that.list.myInviteCode
          });
          // window.webkit.messageHandlers.shareThird.postMessage({body: 'hello world!'});
        }else if(type==="android"){
          window.androidShare.shareThird(status,this.list.myInviteCode);
        }else if(type==="wechat"){
          this.$toast('wechat')
        }else{
          this.$toast('不支持当前设备')
        }
      },

      //获取邀请数据
      getInviteList: function () {
        let data = {
          base: {
            uid: this.uid
          }
        };
        this.$ajax.post("/user/inviteList", data)
          .then(res => {
            window.console.log(res);
            this.list = res.data.data;
          })
          .catch(error => {
            window.console.log(error);
          })
      }
    }
  }
</script>
<style  lang="scss" type="text/scss">
  .invite {
    height: 100vh;
    width: 100vw;
    background-image: url("../assets/images/bg_1.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top center;
    overflow: auto;
    .main{
      padding: 5vw 3vw;
      &>.img{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 15vw 0;
      }
    }
    .kuaigui_text{
      width: 23.2vw;
    }
    .invite_friend{
      width: 70.4vw;
    }
    .park_discount{
      width: 46.9333333vw;
    }
    .detail{
      display: block;
      color: #fff;
      font-size: 3.2vw;
      width: 17.333333vw;
      height: 5.333333vw;
      line-height: 5.333333vw;
      border-radius: 6.666667vw 0 0 6.666667vw;
      background: #ff7200;
      text-align: center;
      position: absolute;
      right: 0;
      top: 10vw;
      z-index: 999
    }
    .activity_detail_block {
      position: relative;
      width: 100%;
      background-color: #fffaec;
      border-radius: 1.333333vw;
      padding: 5vw;
      .ren{
        position: absolute;
        bottom: -6vw;
        right: 0;
        width: 24vw;
        height: auto;
      }
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 6.6666667vw;
      }
      p {
        margin: 0 4vw;
        font-size: 4.8vw;
        font-weight: bold;
      }
    }
    .coupon{
      ul{
        display: flex;
        margin-top: 5vw;
        justify-content: center;
        li{
          width: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 3.2vw;
          color: #ff774e;
          font-weight: bold;
          &:first-child img{
            width: 13.466667vw;
          }
          &:last-child img{
            width: 12.266667vw;
          }
          .friend{
            color: #333;
            margin: 3vw 0;
          }
        }
      }
    }

    .btn{
      button {
        display: block;
        width: 100%;
        height: 10.666667vw;
        line-height: 10.666667vw;
        text-align: center;
        color: #fff;
        background: #ff4e18;
        margin-top: 5.381526vw;
        font-size: 4vw;
        border-radius: 5.333vw;
        border: none
      }
    }

    .statement {
      font-size: 3.2vm;
      color: #666;
      text-align: center;
      margin-top: 2.088353vw;
    }

    .myreward {
      width: 100%;
      background: #fffaec;
      margin: 6vw auto;
      border-radius: 1.333333vw;
      padding: 4.8192771vw 6.666667vw;
    }

    .reward_content{
      ul{
        display: flex;
        margin-top: 5vw;
        li{
          width: 33.333333%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          &>.big{
            display: flex;
            align-items: flex-end;
            font-size: 4.8vw;
            color: #ff4814;
            font-weight: bold;
            &>div{
              font-weight: normal;
              font-size: 3vw;
              margin-bottom: 0.5vw;
              margin-left: 0.4vw;
            }
          }
          &>span{
            font-size: 3.2vw;
            color: #999;
            margin-top: 1.285141vw;
          }
        }
        .twoborder{
          border-left: 1px dotted #ff4814;
          border-right: 1px dotted #ff4814;
        }
      }
    }
    .invite_record{
      width: 100%;
      background: #fffaec;
      border-radius: 1.333333vw;
      padding: 5vw;
      /* margin-bottom: 24.4vw; */
      ul{
        display: flex;
        flex-direction: column;
        margin-top: 5vw;
        li{
          height: 10vw;
          line-height: 5.783133vw;
          display: flex;
          justify-content: space-between;
          div{
            width: 40%;
            padding: 0 1vw;
          }
          .right{
            width: 20%;
            text-align: right;
          }
        }
      }
    }
    .more{
      display: block;
      color: #ff4814;
      text-align: center;
      margin-top: 2vw;
    }
    .ordered{
      color: #ff4814;
    }
    .share{
      width: 100%;
      height: 24.4vw;
      background: #fff;
      /* position: absolute;
      bottom: 0;
      left: 0; */
      ul{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        li{
          width: 25%;
          display: flex;
          align-items: center;
          justify-content: center;
          a{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img{
              width: 13.333333vw;
            }
          }
        }
      }
    }
    .right_up_detail{
      width: 17.333333vw;
      height: 3.373494vw;
      line-height: 3.373494vw;
      background: #ff7200;
      border-radius: 6.666667vw 0 0 6.666667vw;
      position: absolute;
      right: 0;
      top: 7.5vw;
      text-align: center;
      a{
        color: #fff;
        font-size: 3.2vw;
      }
    }
    .list_null{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #999999;
      font-size: 3.2vw;
      padding: 6vw 0;
      img{
        width: 25vw;
        height: auto;
        margin-bottom: 1vw;
      }
    }
  }
</style>